/**
 * Resolved with fetched cm token string.
 * Headers are set to prevent caching. There is a change that token is stored to disk cache wihtout headers provided.
 * @returns {Promise<string>} token
 */
export async function getToken() {
  const tokenResponse = await fetch('/stage-ajax/get-token', { headers: { 'Cache-Control': 'no-cache' }});
  const token = await tokenResponse.json();
  return token?.token;
}


/**
 * Inject <input type="hidden" name="cmtoken" value="cmtoken" /> to form element in the page.
 * @param {string} selector selector for finding form where are cm token is to be injected
 */
function injectCMTokenToForms( selector ) {

  const formElements = document.querySelectorAll(selector);

  if( formElements.length > 0 ) {
    getToken().then(cmtoken => {
      formElements.forEach(( formElement ) => {

        var element = document.createElement('input');
        element.setAttribute('type','hidden');
        element.setAttribute('name','cmtoken');
        element.setAttribute('value', cmtoken);

        formElement.appendChild( element );
      });
    });
  }
}

/**
 * On initialization cm-token is read from the server and injected to each form element that has .inject-cm-token class.
 */
function init() {
  injectCMTokenToForms('form.inject-cm-token');
}

export default {
  injectCMTokenToForms,
  init
}
